// extracted by mini-css-extract-plugin
var _1 = "ApplicantIdentityWidgetName-moduleavatar__fs10o";
var _2 = "ApplicantIdentityWidgetName-modulecontent__kYdXg";
var _3 = "ApplicantIdentityWidgetName-modulelabel__W74ys";
var _4 = "ApplicantIdentityWidgetName-modulevalue__fWM4E";
export { _1 as "avatar", _2 as "content", _3 as "label", _4 as "value" }
